<template>
	<page>
		<title-view>{{$t('pages.clientsView.title')}}
      <template v-slot:actions>

        <div class="d-flex align-content-center" style="flex-wrap: wrap">
          <v-btn  href="export/clients" class="btn-mobile blue ml-2 " color="primary" btn>
            <v-icon light>mdi-file-download-outline</v-icon>
            יצוא טבלת מחירים
          </v-btn>
          <v-btn btn @click="onEdit({})">{{ $t('attributes.add') + "  " + $t('pages.clientsView.clientCompany') }}
          </v-btn>
        </div>
      </template>
		</title-view>
		<row>
			<c-col>
				<clients-table @edit="onEdit" @branch="onBranch" @deleteBranch="deleteBranch"/>
			</c-col>
		</row>
		<popup-dialog v-model="openModal">
			<span slot="header">{{$t("attributes.addOrEdit")+ "  " + $t("attributes.customer")}}</span>
			<client-form @save="openModal=false"/>
		</popup-dialog>

		<popup-dialog v-model="branchModalOpen" :max-width="900">
			<span slot="header">{{$t("attributes.add") + "  " + $t("pages.projectForm.branch")}}</span>
			<branch-form @save="onBranchSave"/>
		</popup-dialog>
	</page>
</template>

<script>
	import ClientForm from "src/view/clients/ClientForm";
	import ClientsTable from "src/view/clients/ClientsTable";
	import {types} from "dev/store/modules/Client.module";
	import {types as BranchType} from "dev/store/modules/Branch.module";
	import BranchForm from "src/view/branches/BranchForm";

	export default {
		name: "clients-view",
		components: {ClientsTable, ClientForm, BranchForm},
		data() {
			return {
				openModal: false,
				branchModalOpen: false,
			};
		},
		methods: {
			deleteBranch(branch) {
				this.$store.dispatch(BranchType.REMOVE, branch);

			},
			onEdit(Client) {
				this.$store.commit(types.GET, Client);
				this.openModal = true;
			},
			onBranch(branch) {
				if (branch.id){
					this.$store.commit(BranchType.GET, branch);
				}else {
					this.$store.commit(BranchType.CREATE, branch);
				}
				this.branchModalOpen = true;
			},
			onBranchSave(branch) {
				this.branchModalOpen = false;
				this.$store.commit(types.SAVE_SUB_MODEL, {
					name:"branches",
					model:branch,
					id:branch.client_id
				});
			}
		}

	};
</script>

<style scoped>

</style>
